import type { Device } from '../hooks/useDeviceDiscovery';
import './DevicePicker.css';

interface DevicePickerProps {
  devices: Device[];
  onSelect: (device: Device) => void;
  onRefresh: () => void;
  onLogout: () => void;
  loading: boolean;
  username: string;
}

export function DevicePicker({ devices, onSelect, onRefresh, onLogout, loading, username }: DevicePickerProps) {
  const onlineDevices = devices.filter(d => d.online);
  const offlineDevices = devices.filter(d => !d.online);

  return (
    <div className="picker-page">
      <div className="picker-card">
        <div className="picker-logo">🦞</div>
        <h1 className="picker-title">选择设备</h1>
        <p className="picker-subtitle">
          {onlineDevices.length > 0
            ? '选择要连接的电脑'
            : '没有在线的设备'}
        </p>

        {loading && <div className="picker-loading">查找设备中...</div>}

        <div className="picker-list">
          {onlineDevices.map((d) => (
            <button
              key={d.machine_id}
              className="picker-device online"
              onClick={() => onSelect(d)}
            >
              <span className="picker-device-icon">💻</span>
              <span className="picker-device-name">
                {d.machine_name || d.machine_id}
              </span>
              <span className="picker-device-status online">在线</span>
            </button>
          ))}

          {offlineDevices.map((d) => (
            <div key={d.machine_id} className="picker-device offline">
              <span className="picker-device-icon">💻</span>
              <span className="picker-device-name">
                {d.machine_name || d.machine_id}
              </span>
              <span className="picker-device-status offline">离线</span>
            </div>
          ))}
        </div>

        {devices.length === 0 && !loading && (
          <div className="picker-empty">
            <p>还没有绑定任何设备</p>
            <p className="picker-hint">在你的电脑上安装并运行 Lobster，登录同一账号即可自动绑定</p>
          </div>
        )}

        {onlineDevices.length === 0 && devices.length > 0 && (
          <div className="picker-empty">
            <p>设备不在线</p>
            <p className="picker-hint">请确认 Lobster 正在你的电脑上运行</p>
          </div>
        )}

        <button className="picker-refresh" onClick={onRefresh}>
          刷新
        </button>

        <div className="picker-footer">
          <span className="picker-username">{username}</span>
          <span className="picker-logout" onClick={onLogout}>退出登录</span>
        </div>
      </div>
    </div>
  );
}
